interface Props {
  onLegalClick: () => void;
  onPrivacyClick?: () => void;
  onTermsClick?: () => void;
  onSubprocessorsClick?: () => void;
}

export default function Footer({ onLegalClick, onPrivacyClick, onTermsClick, onSubprocessorsClick }: Props) {
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 shader:border-white/10 pastel:border-t-0 pastel:bg-transparent px-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-slate-400 dark:text-slate-500 shader:text-white min-h-[61px] py-2 shrink-0 shader:bg-black/20 shader:backdrop-blur-sm">
      <span>Outil d'aide &agrave; la d&eacute;cision &mdash; non-opposable.</span>
      <button
        onClick={onLegalClick}
        className="underline hover:text-slate-600 dark:hover:text-slate-300 shader:hover:text-white/70 transition-colors"
      >
        Mentions l&eacute;gales
      </button>
      {onPrivacyClick && (
        <button
          onClick={onPrivacyClick}
          className="underline hover:text-slate-600 dark:hover:text-slate-300 shader:hover:text-white/70 transition-colors"
        >
          Confidentialit&eacute;
        </button>
      )}
      {onTermsClick && (
        <button
          onClick={onTermsClick}
          className="underline hover:text-slate-600 dark:hover:text-slate-300 shader:hover:text-white/70 transition-colors"
        >
          CGU
        </button>
      )}
      {onSubprocessorsClick && (
        <button
          onClick={onSubprocessorsClick}
          className="underline hover:text-slate-600 dark:hover:text-slate-300 shader:hover:text-white/70 transition-colors"
        >
          Sous-traitants
        </button>
      )}
    </footer>
  );
}
